import { email } from 'vee-validate/dist/rules';
import i18n from './../langs/i18n.js';

export default function addVeeValidateRules (VeeValidateExtend) {
  VeeValidateExtend('required', {
    validate: value => value !== null && String(value).trim() !== '',
    computesRequired: true,
    message: i18n.t('validation.required')
  });

  VeeValidateExtend('required_always', {
    validate: value => value !== null && typeof value !== 'undefined' && String(value).trim() !== '',
    computesRequired: true,
    message: i18n.t('validation.required')
  });

  VeeValidateExtend('non_zero', {
    validate: value => value !== null && String(value).trim() !== '' && value > 0,
    computesRequired: true,
    message: i18n.t('validation.youMustSelectValue')
  });

  VeeValidateExtend('email', {
    ...email,
    message: i18n.t('validation.validEmailRequired')
  });

  VeeValidateExtend('doubleVal', {
    validate: value => {
      if (typeof value !== 'string') {
        value = (value).toString();
      }

      if (value.toString().trim() === '') {
        return true;
      }

      if (value.indexOf(',') > -1) {
        return false;
      }

      let doubleValPattern1 = new RegExp('^[0-9]{1,}\.[0-9]{1,2}$', 'i');
      let doubleValPattern2 = new RegExp('^[0-9]{1,}$', 'i');
      return !!doubleValPattern1.test(value) || !!doubleValPattern2.test(value);
    },
    computesRequired: true,
    message: i18n.t('validation.validDoubleNumericRequired')
  });

  VeeValidateExtend('valid-url', {
    validate: value => {
      if (value === null || value === undefined) {
        value = '';
      }

      if (value.trim() === '') {
        return true;
      }

      let urlPattern = new RegExp('^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-@a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$', 'i');
      return !!urlPattern.test(value);
    },
    computesRequired: true,
    message: i18n.t('validation.validUrlRequired')
  })

  VeeValidateExtend('only-big-letters', {
    validate: value => value === value.replace(/[^A-Z]/gm, ''),
    computesRequired: true,
    message: i18n.t('validation.onlyBigLetters')
  });

  VeeValidateExtend('only-numbers', {
    validate: value => value === value.replace(/[^0-9.]/gm, '') && !Number.isNaN(parseFloat(value.replace(/[^0-9.]/gm, ''))),
    computesRequired: true,
    message: i18n.t('validation.onlyNumbers')
  });

  VeeValidateExtend('only-integer-numbers', {
    validate: value => (value).toString() === (value).toString().replace(/[^0-9]/gm, '') && !Number.isNaN(parseInt((value).toString().replace(/[^0-9]/gm, ''), 10)),
    computesRequired: true,
    message: i18n.t('validation.onlyNumbers')
  });

  VeeValidateExtend('only-letters-and-dashes', {
    validate: value => value === value.replace(/[^a-zA-Z-]/gm, ''),
    computesRequired: true,
    message: i18n.t('validation.onlyLettersAndDashes')
  });

  VeeValidateExtend('only-letters-and-numbers', {
    validate: value => value === value.replace(/[^a-zA-Z0-9]/gm, ''),
    computesRequired: true,
    message: i18n.t('validation.onlyLettersAndNumbers')
  });

  VeeValidateExtend('min', {
    params: ['min'],
    validate: (value, { min }) => value.length >= min,
    message: (field, params) => {
      if (params.min === 1) {
        return i18n.t('validation.fieldCanContainAtLeast1Char');
      }

      if (params.min >= 2 && params.min <= 4) {
        return i18n.t('validation.fieldCanContainAtLeast24Chars', { min: params.min });
      }

      return i18n.t('validation.fieldCanContainAtLeast24Chars', { min: params.min });
    }
  });

  VeeValidateExtend('max', {
    params: ['max'],
    validate: (value, { max }) => value.length <= max,
    message: (field, params) => {
      if (params.max === 1) {
        return i18n.t('validation.fieldCanContainAtMax1Char');
      }

      if (params.max >= 2 && params.max <= 4) {
        return i18n.t('validation.fieldCanContainAtMax24Chars', { max: params.max });
      }

      return i18n.t('validation.fieldCanContainAtMaxNChars', { max: params.max });
    }
  });

  VeeValidateExtend('min_value', {
    params: ['minValue'],
    validate: (value, { minValue }) => parseFloat(value) >= parseFloat(minValue),
    message: (field, params) => i18n.t('validation.valueCannotBeLessThan') + params.minValue
  });

  VeeValidateExtend('max_value', {
    params: ['maxValue'],
    validate: (value, { maxValue }) => parseFloat(value) <= parseFloat(maxValue),
    message: (field, params) => i18n.t('validation.valueCannotBeGreaterThan') + params.maxValue
  });

  VeeValidateExtend('password', {
    params: [{
      name: 'original',
      isTarget: true
    }],
    validate: (value, { original }) => value === original,
    message: i18n.t('validation.passwordsAreNotIdentical')
  });

  VeeValidateExtend('value_contains', {
    params: ['valueToCheck'],
    validate: (value, { valueToCheck }) => value.indexOf(valueToCheck) > -1,
    message: (field, params) => i18n.t('validation.valueMustContainOrderID') + params.valueToCheck
  });

  VeeValidateExtend('required_date_range', {
    validate: value => value.startDate !== null && value.endDate !== null,
    computesRequired: true,
    message: i18n.t('validation.requiredDateRange')
  });

  VeeValidateExtend('required_true', {
    validate: value => value === true || value === 1 || value === '1' || value === 'true',
    computesRequired: true,
    message: i18n.t('validation.checkRequired')
  });
};
